import React, { useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { ShareAndRestrictDialogController } from '@confluence/share-and-restrict-dialog/entry-points/ShareAndRestrictDialogController';
import type { ContentType } from '@confluence/share-and-restrict-dialog';

import { PublishModalContext } from './PublishModalContext';

export type ShareAndRestrictDialogInPublishModalProps = {
	onClose: () => void;
	contentId: string;
	contentType: ContentType;
	isUnpublishedDraft: boolean;
};

export const ShareAndRestrictDialogInPublishModal = ({
	onClose,
	contentId,
	contentType,
	isUnpublishedDraft,
}: ShareAndRestrictDialogInPublishModalProps) => {
	const {
		restrictionsRestObj,
		setRestrictionsRestObj,
		hasModifiedRestrictions,
		hasScheduledRestrictions,
	} = useContext(PublishModalContext);

	const setRestrictionsDeepCopy = (newVal) => {
		const clone = cloneDeep(newVal);
		setRestrictionsRestObj(clone);
	};
	const preloadRestrictions =
		hasModifiedRestrictions || hasScheduledRestrictions ? restrictionsRestObj : undefined;

	return (
		<ShareAndRestrictDialogController
			contentId={contentId}
			contentType={contentType}
			allowRestrictions
			pageModes="view"
			refetchButtonData={() => {}}
			onClose={onClose}
			publishModalRestrictions={preloadRestrictions}
			pushPublishModalRestrictions={setRestrictionsDeepCopy}
			isUnpublishedDraft={isUnpublishedDraft}
		/>
	);
};
